import { render, staticRenderFns } from "./OkrViewInfo.vue?vue&type=template&id=604faf8f&"
import script from "./OkrViewInfo.vue?vue&type=script&lang=js&"
export * from "./OkrViewInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports